"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-4 w-16 bg-muted-dark-background/40 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted-dark-background/40 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted-dark-background/40 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex gap-6">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-sm text-foreground-dark hover:text-accent hover:underline underline-offset-4 transition-all duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }];
  return <footer id="pied-de-page" className="bg-dark-background text-foreground-dark py-6 border-t border-border-strong/20">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="text-sm text-foreground order-3 md:order-1">Agence de communication à Paris – Branding – Marketing physique et digital – Île-de-France</div>

          {}
          <div className="flex gap-4 order-1 md:order-2">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} newTab aria-label={social.label} data-index={i} className="text-foreground-dark/70 hover:text-accent transition-colors duration-[var(--duration-fast)]">
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>

          {}
          <div className="order-2 md:order-3">
            <MenuProvider menu_id="4">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>
        </div>
      </div>
    </footer>;
}